var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "md:pl-10 w-full md:w-3/4 md:pr-10" },
    [
      _c("h1", { staticClass: "mt-2 mb-6 font-sans-bold" }, [
        _vm._v("Event Logos"),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "mb-5" }, [
        _vm._v(
          "Logos are OPTIONAL. If you have a logo and/or logos for supporting or sponsoring organizations, upload them here and they will appear at the bottom of your event details page. You can include up to 10. Please use web-ready images sized at 500 pixels wide (height will be variable based on logo)."
        ),
      ]),
      _vm._v(" "),
      _vm._l(_vm.form.images, function (image, index) {
        return _c("div", { staticClass: "border-b border-grey-dark mb-10" }, [
          _c("div", { staticClass: "mb-6 mr-2" }, [
            _vm._m(0, true),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'",
                },
              ],
              attrs: { type: "file", name: "image" },
              on: {
                change: function ($event) {
                  return _vm.processFile($event, index)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("image"),
                    expression: "errors.has('image')",
                  },
                ],
                staticClass: "error text-error-red text-lg block",
              },
              [_vm._v(_vm._s(_vm.errors.first("image")))]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "w-full mb-6 mr-2" }, [
            _vm._m(1, true),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.images[index].url,
                  expression: "form.images[index].url",
                },
              ],
              attrs: { id: "form.url", type: "text", name: "url" },
              domProps: { value: _vm.form.images[index].url },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form.images[index], "url", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("url"),
                    expression: "errors.has('url')",
                  },
                ],
                staticClass: "error text-error-red text-lg",
              },
              [_vm._v(_vm._s(_vm.errors.first("url")))]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "w-full mb-10 mr-2" }, [
            _vm._m(2, true),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.form.images[index].title,
                  expression: "form.images[index].title",
                },
              ],
              attrs: { id: "title", type: "text", name: "title" },
              domProps: { value: _vm.form.images[index].title },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.form.images[index], "title", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("title"),
                    expression: "errors.has('title')",
                  },
                ],
                staticClass: "error text-error-red text-lg",
              },
              [_vm._v(_vm._s(_vm.errors.first("title")))]
            ),
          ]),
        ])
      }),
      _vm._v(" "),
      _vm.form.images.length < 10
        ? _c("div", { staticClass: "mb-6 text-right" }, [
            _c(
              "button",
              {
                staticClass: "button button__small",
                on: { click: _vm.addImage },
              },
              [_vm._v("Add Another Logo")]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.imagesExist
        ? _c("div", [
            _c(
              "h2",
              { staticClass: "block font-sans-bold text-2xl text-black mb-2" },
              [_vm._v("Your Logos")]
            ),
            _vm._v(" "),
            _c(
              "table",
              { staticClass: "w-full mb-5" },
              [
                _vm._m(3),
                _vm._v(" "),
                _vm._l(_vm.images, function (image) {
                  return _c("tr", [
                    _c("td", { staticClass: "p-2 border border-grey-light" }, [
                      _c("img", {
                        attrs: {
                          src: image.fullPath + "?auto=format&fit=scale&h=80",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "p-2 border border-grey-light" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(image.url) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "border border-grey-light" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(image.title) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "border border-grey-light" }, [
                      _c(
                        "button",
                        {
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.deleteLogo(image.id)
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                "xmlns:xlink": "http://www.w3.org/1999/xlink",
                                width: "35",
                                height: "35",
                                viewBox: "0 0 100 100",
                              },
                            },
                            [
                              _c("g", [
                                _c(
                                  "g",
                                  {
                                    staticStyle: { fill: "#000000" },
                                    attrs: {
                                      transform:
                                        "translate(50 50) scale(0.69 0.69) rotate(0) translate(-50 -50)",
                                    },
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        staticStyle: {
                                          "enable-background":
                                            "new 0 0 100 100",
                                        },
                                        attrs: {
                                          fill: "#000000",
                                          xmlns: "http://www.w3.org/2000/svg",
                                          "xmlns:xlink":
                                            "http://www.w3.org/1999/xlink",
                                          version: "1.1",
                                          x: "0px",
                                          y: "0px",
                                          viewBox: "0 0 100 100",
                                          "xml:space": "preserve",
                                        },
                                      },
                                      [
                                        _c("rect", {
                                          attrs: {
                                            x: "33.1",
                                            y: "38.8",
                                            width: "5.6",
                                            height: "45",
                                          },
                                        }),
                                        _c("rect", {
                                          attrs: {
                                            x: "47.2",
                                            y: "38.8",
                                            width: "5.6",
                                            height: "45",
                                          },
                                        }),
                                        _c("rect", {
                                          attrs: {
                                            x: "61.2",
                                            y: "38.8",
                                            width: "5.6",
                                            height: "45",
                                          },
                                        }),
                                        _c("path", {
                                          attrs: {
                                            d: "M86.6,16.2H66.9V5H33.1v11.2H13.4v16.9H19V95h61.9V33.1h5.6L86.6,16.2L86.6,16.2z M38.8,10.6h22.5v5.6H38.8V10.6z   M19.1,21.9h14.1H67h14.1v5.6h-62V21.9z M75.3,89.4H24.7V33.1h50.6V89.4z",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ])
                }),
              ],
              2
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "mb-6 text-right" }, [
        _c(
          "button",
          {
            staticClass: "button mr-4",
            class: { "opacity-50 cursor-not-allowed": _vm.saving },
            attrs: { disabled: _vm.saving },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.save.apply(null, arguments)
              },
            },
          },
          [_vm.saving ? [_vm._v("Processing...")] : [_vm._v("Save")]],
          2
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button",
            class: { "opacity-50 cursor-not-allowed": _vm.saving },
            attrs: { disabled: _vm.saving },
            on: {
              click: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.saveNext.apply(null, arguments)
              },
            },
          },
          [_vm._v("Save & Next")]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "hidden", attrs: { for: "image" } }, [
      _vm._v("\n                Image "),
      _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "url" } }, [
      _vm._v("\n                URL\n                "),
      _c("div", { staticClass: "text-sm font-sans-book" }, [
        _vm._v(
          "This will be the website the logo links to. Please provide a fully qualified URL - must include http:// or https:// (e.g., https://www.letsreimagine.com)."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { attrs: { for: "title" } }, [
      _vm._v("\n                Title\n                "),
      _c("div", { staticClass: "text-sm font-sans-book" }, [
        _vm._v(
          "This is used for accessibility. We recommend using the name of the organization corresponding to the logo."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { staticClass: "text-left p-2 border border-grey-light" }, [
          _vm._v("Image"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-left p-2 border border-grey-light" }, [
          _vm._v("URL"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-left p-2 border border-grey-light" }, [
          _vm._v("Title"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "text-left p-2 border border-grey-light" }, [
          _vm._v("Action"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }